/**
 * Created by calhosh on 2/4/2025
 */

import React from 'react';
import styled from 'styled-components';
import Icon from '../../../Common/BaseComponentWrappers/MotifIcon';
import {IconoirAttachment} from '@ey-xd/motif-icon';
import {labels} from '../../../../util/utils';

export default function RelatedDocuments(props) {
	const {count, bodyId, onClick} = props;

	return (
		<StyledRelatedDocument className="StyledRelatedDocument" key={bodyId} onClick={onClick}>
			<StyledRelatedDocumentIcon className="StyledRelatedDocumentIcon">
				<section className="relatedDocumentCount">{count}</section>
				<Icon size={'16'} src={IconoirAttachment} title={labels.relatedDocuments} />
			</StyledRelatedDocumentIcon>
		</StyledRelatedDocument>
	);
}

const StyledRelatedDocument = styled.section`
	min-width: var(--px-60);
	max-width: var(--px-60);
	min-height: var(--px-32);
	display: flex;
	justify-content: center;
	align-items: center;
	padding: var(--px-5);
	&:hover,
	&:focus,
	&.activated {
		background-color: var(--neutrals-900) !important;
		border-radius: var(--px-20) 0 0 var(--px-20);
		cursor: pointer;
		.relatedDocumentCount {
			color: var(--neutrals-00white) !important;
		}
		svg {
			fill: var(--neutrals-00white) !important;
			path {
				fill: var(--neutrals-00white) !important;
			}
		}
	}
`;
const StyledRelatedDocumentIcon = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	.relatedDocumentCount {
		font-size: var(--px-12);
		font-weight: 400;
		line-height: var(--px-18);
		color: var(--neutrals-700);
		margin-right: var(--px-4);
	}
	.motif-icon {
		display: flex;
		align-items: center;
		svg {
			width: var(--px-16);
			height: var(--px-16);
			color: var(--neutrals-700);
			path {
				color: var(--neutrals-700);
			}
		}
	}
`;
